/**
 * Visit Journey API — single read-only endpoint backing the inline
 * timeline mounted on doctor / manage / receptionist surfaces.
 */
import apiClient from './apiClient';

const BASE = '/api/organisation/visits';

/**
 * @param {string} visitId
 * @param {{ lens?: 'admin'|'doctor'|'receptionist'|'nurse'|null }} [opts]
 *   When `lens` is provided, the backend shapes the response per role
 *   (filters clinical content for receptionist, scopes nurse to their
 *   own events, etc.). When omitted, defaults to the caller's role.
 */
export const fetchVisitJourney = async (visitId, opts = {}) => {
  const params = {};
  if (opts && opts.lens) params.lens = opts.lens;
  const { data } = await apiClient.get(`${BASE}/${visitId}/journey`, { params });
  return data;
};
